<template>
    <div :key="$store.getters['resource/currentResource'].key">

        <help :title="$t('help.invites_used_title')" >
            <div v-if="invite"
                 slot="text"
                 class="p-3">Invite: <router-link :to="'/promos/edit/' + invite.id">{{invite.title}}</router-link></div>
        </help>

        <div class="position-relative">

            <loader v-if="loading"/>

            <v-server-table
                    ref="appTable"
                    class="white-container"
                    :url="tableFetchURL"
                    :columns="columns"
                    :options="options"
                    @loaded="loading = false"
                    @loading="loading = true">

                <template slot="beforeFilter" class="w-100">
                    <div class="w-100 d-flex flex-row flex-wrap">
                        <div class="mt-2 d-flex flex-row align-items-center mr-4">
                            <b-input
                                    v-model="targetEmail"
                                    id="target_email"
                                    type="email"
                                    class="w-50 rounded mr-4"
                                    name="target_email"
                                    placeholder="Enter recipient email">
                            </b-input>
                            <i class="far fa-file-excel fa-lg ml-1 mr-1 text-primary d-block"></i>
                            <b-link @click="generateXmlList({filter: params, download: true, email: targetEmail}, 'users')">
                                {{$t('global.generate_send_on_email')}}
                            </b-link>
                        </div>
                    </div>
                </template>
                <template slot="id" slot-scope="props">
                    <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">
                        <span class="text-capitaliloadingze">{{props.row.id}}</span>
                    </router-link>
                </template>
                <template slot="beforeLimit" v-if="totalRecordsCount > 10">
                    {{$t('global.showing')}}&nbsp;
                </template>
                <template slot="afterLimit" v-if="totalRecordsCount > 10">
                    &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
                </template>
                <template slot="full_name" slot-scope="props">
                    <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">
                        <span class="text-capitaliloadingze">{{props.row.first_name}} {{props.row.last_name}}</span>
                    </router-link>
                </template>
            </v-server-table>
        </div>
    </div>
</template>

<script>
  import axios from '@/utils/axios';
  import i18n from "@/utils/i18n";

  export default {
    name: "InviteUsers",
    middleware: 'auth',
    data() {
      return {
        loading: false,
        targetEmail: null,
        params: null,
        columns: ['id', 'full_name', 'email'],
        options: {
          skin: [],
          headings: {
            id: '#',
            full_name: i18n.t('users.full_name'),
            email: i18n.t('users.email'),
            used_at: i18n.t('promo.used_at'),
            transaction_id: i18n.t('transactions.transaction_id'),
            purchase_name: i18n.t('transactions.purchase_name'),
            transaction_total: i18n.t('transactions.amount'),
            transaction_discounted_total: i18n.t('transactions.discounted_amount')
          },
          dateColumns: ['used_at'],
          sortable: [],
          clientMultiSorting: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            let params = {};
            params.limit = data.limit;
            params.filter = data.custom;
            params.page = data.page;

            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: params
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data ? data.data.items : [],
              count: data ? data.data.paginator.total_items : 0
            }
          }
        },
        totalRecordsCount: 0,
        show: false,
        invite: null
      }
    },
    created() {
      this.show = !!this.$route.params.id;
      if (!this.$route.params.id) {
        this.$router.push({path: '/invites'})
      }

      this.fetchInvite(this.$route.params.id);
    },
    methods: {
      fetchInvite(id) {
        axios.get('/admin/invites/' + id).then(({data}) => {
          if (data) {
            this.invite = data;
            this.params = {"invites.code" : this.invite.code};
          }
        }).catch((e) => {
          this.dispatch('error', e);
        });
      }
    },
    computed: {
      tableFetchURL() {
        return "/admin/invites/info/" + this.$route.params.id;
      }
    },
  }
</script>